<template>
  <div id="climboprojects">

    <md-dialog-confirm
      :md-title="erase.title"
      :md-content-html="erase.contentHtml"
      :md-ok-text="erase.ok"
      :md-cancel-text="erase.cancel"
      @open="onOpen"
      @close="onErase"
      ref="dialog4">
    </md-dialog-confirm>

    <div>
      <md-list v-if="!isProject" style="margin-top:80px;">
        <md-list-item>
          <div style="text-align:center; margin-top:20px;">
            <span class="md-caption">Markiere Routen als Deine Projekte, um sie hier anzuzeigen. Gehe zur Detailseite einer Route und klicke auf das Herz Symbol um die Route als Projekt zu markieren.</span>
          </div>
        </md-list-item>
      </md-list>

      <md-list v-else class="custom-list md-triple-line" style="position:relative; z-index:10; margin-top:72px;">
        <md-list-item v-for="projects in projectRoutes" :key="projects.name"
            @click="projectActive(projects)">
          <md-avatar style="font-weight: 500; background-color:rgb(217, 236, 238);">{{ projects.grade }}</md-avatar>
          <div class="md-list-text-container" style="width:120px;">
            <span class="md-title">{{ projects.routeName }}</span>

            <span style="display:inherit;">
              <div v-show="isRecent(projects.dateCreated)" class="neuTag">NEU</div>
              <md-rating-bar v-model="projects.rating.value" class="md-accent" md-theme="orange" disabled></md-rating-bar>

              <span style="margin-top:6px;">
                <span class="md-caption">({{ projects.rating.count }})</span>
                <span class="md-caption" v-show="(projects.isLead)">V</span>
                <span class="md-caption" v-show="(projects.isToprope)">T</span>
                <span class="md-caption" v-show="projects.remarks"> | {{ projects.remarks }}</span>
              </span>
            </span>
          </div>

          <span v-if="projectTrash">
            <md-button style="margin-right:-6px !important;" class="md-icon-button md-list-action md-accent" @click="projectActive(projects), openDialog('dialog4')">
              <md-icon style="font-size:28px">remove_circle</md-icon>
            </md-button>
          </span>

          <span v-else>
            <span v-if="projects.color == 'mixed'">
              <md-icon class="mixedColor"></md-icon>
            </span>
            <span v-else-if="projects.color == 'white'">
              <md-icon class="whiteColor"></md-icon>
            </span>
            <span v-else>
              <md-icon :class="projects.color" v-bind:style="{ backgroundColor: projects.color }"></md-icon>
            </span>
          </span>

          <md-divider class="md-inset"></md-divider>
        </md-list-item>
      </md-list>
    </div>

  </div>

</template>

<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'climboprojects',

  data () {
    return {
      userInfo: {
        title: 'Someuser'
      },
      isProject: false,
      compareSector: '',
      erase: {
        title: '',
        contentHtml: 'Route wirklich aus Projekten löschen?',
        ok: 'Löschen',
        cancel: 'Abbrechen'
      }
    }
  },

  created () {
      this.gettingProjects()
  },

  computed: {
    ...mapState([
      'projectRoutes',
      'projectsId',
      'validUser',
      'sectorDetails',
      'userPrivileges',
      'projectTrash',
      'isSidebar',
      'projectLoading'
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },

  },

  watch: {
    '$route': 'gettingProjects'
  },

  methods: {
    ...mapMutations([
      'changeProjects',
      'changeProjectsId',
      'loadRating',
      'changeActive',
      'changeProjectTrash',
      'changeProjectLoad',
      'changeMarker'
    ]),

    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },

    onOpen () {
      // console.log('Opened')
    },

    onErase (type) {
      if (type === 'ok') {
        var removeProject = {}
        removeProject.action = 'remove'

        var whatProject = JSON.stringify(removeProject)
        this.$store.dispatch('removeProject', whatProject)
        .then(response => {
          this.gettingProjects()
        }, error => {
          // console.error
        })

      }
    },

    isRecent (item) {
      var neuCal = ( this.today - item ) / 86400000
      if (neuCal < 30) {
        return true
      } else {
        return false
      }
    },

    gettingProjects () {
      this.changeProjectLoad(true)
      var projectLink = this.userPrivileges.links.projectRoutes
      this.compareSector = this.sectorId

      this.$http.get(projectLink)
        .then(function (response) {
          if (response.data.projectRoutes.length > 0 ) {
            this.isProject = true
            this.changeProjects(response.data.projectRoutes)
            this.changeProjectsId(response.data.projectRoutes.map(a => a.id))
          } else {
            this.isProject = false
          }
          this.changeProjectLoad(false)

        }, response => {
          console.log('error')
        })

    },

    projectActive (item) {
      if (!this.projectTrash) {
        var resLink = item.links.sector
        var detLink = item.links.route

        this.pageTitle = 'Loading...'
        this.$store.dispatch('getSector', resLink)

        var ifsector = 'climbo-backend/v1/sector/'
        var diffSector = resLink.replace(ifsector,'')

        if (diffSector = this.sectorDetails.id) {

        } else {
          this.$store.dispatch('getSector', resLink)
          this.$store.state.filterSet = 'C'

          setTimeout(() => {
            this.$store.state.pageLoading = true
            this.$store.dispatch('getList', this.sectorDetails.links.routes)
          }, 600)
        }

        setTimeout(() => {
          this.$http.get(detLink)
            .then(function (response) {
              this.activeDetails = response.data
              this.changeActive(this.activeDetails)

              if(this.validUser.hash) {
                this.$store.dispatch('getRouteStatements', this.activeDetails.links.route)
                this.$store.dispatch('getRatingStatement', this.activeDetails.links.ratingStatement)
              }

              if (this.activeDetails) {
                this.changeProjectTrash(false)

                this.pageTitle = 'Routenbuch'
                this.$router.push('RouteDetails')
              }
              this.changeMarker()
            })

        }, 600)

      } else {
        this.changeActive(item)
        this.erase.title = item.routeName
      }
    },
  }
}

</script>

<style>

</style>
